import { render, staticRenderFns } from "./Demonstracoes.vue?vue&type=template&id=486ee291&scoped=true&lang=pug"
import script from "./Demonstracoes.vue?vue&type=script&lang=js"
export * from "./Demonstracoes.vue?vue&type=script&lang=js"
import style0 from "./Demonstracoes.styl?vue&type=style&index=0&id=486ee291&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486ee291",
  null
  
)

export default component.exports